module.exports = __webpack_public_path__ + "static/10-9e39d5f6bbd8a6df9654a71ea60c06d1.png";